import { Component } from 'react'
import { withTranslation } from 'react-i18next'
import { Router } from 'react-router'
import { Routes } from './App.Routes'
// import ConfirmationAlert from '@modules/kernel/ConfirmationAlert'
import { history } from '@services/History'
import ReactTooltip from 'react-tooltip'
import { connect } from 'react-redux'
import '@modules/admin/MD.Form.scss'
import moment from 'moment'
import { FEATURE_FLAG_MAINTENANCE_MODE } from '@/environment/environment.constant'

class App extends Component {
  componentDidMount() {
    moment.locale(this.props.i18n.language)
  }
  render() {
    return (
      <div style={styles.appContainer}>
        {FEATURE_FLAG_MAINTENANCE_MODE ? (
          <span>Maintenance mode</span>
        ) : (
          <>
            <Router history={history}>
              <Routes />
            </Router>
            {/* <ConfirmationAlert /> */}
            <ReactTooltip />
          </>
        )}
      </div>
    )
  }
}

const styles = {
  appContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
}

export default connect()(withTranslation()(App))
